import React from 'react';
const tones: Record<string, string> = {
  'Submitted For Review': 'bg-ink-100 text-ink-600',
  'Claim Rejected': 'bg-red-50 text-red-700',
  'Beyond Economic Repair': 'bg-red-50 text-red-700',
  Repaired: 'bg-emerald-50 text-emerald-700',
  'Received By Shop': 'bg-brand-50 text-brand-700',
  'In Transit': 'bg-brand-50 text-brand-700',
  Completed: 'bg-emerald-50 text-emerald-700',
  'Approved for Same Unit Repair': 'bg-amber-50 text-amber-700',
  Shipped: 'bg-emerald-50 text-emerald-700',
  'Packing In Progress': 'bg-brand-50 text-brand-700'
};
export function StatusPill({
  status
}: {
  status: string;
}) {
  return <span className={`inline-block whitespace-nowrap rounded px-2 py-1 text-[12px] font-medium ${tones[status] ?? 'bg-ink-100 text-ink-600'}`} data-id="element-400" data-mp="edfgr2g46xb9">
      {status}
    </span>;
}
export function SeatsIndicator({
  used,
  total
}: {
  used: number;
  total: number;
}) {
  return <span className="inline-flex items-center gap-2 whitespace-nowrap" data-id="element-401" data-mp="jf4oo981iuv4">
      <span className="h-2 w-2 rounded-full bg-red-500" aria-hidden="true" data-id="element-402" data-mp="asg8cky7wq54" />
      {used} of {total}
    </span>;
}